<template>
  <component :is="href ? 'a' : 'span'" :href="href" class="def-link">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'DefLink',
  props: {
    href: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.def-link {
  cursor: pointer;
  color: #618eaf;
}
a.def-link {
  text-decoration-line: underline;
  text-underline-position: under;
  transition: 0.2s linear color;
  text-underline-color: currentColor;
  &:hover {
    text-decoration-style: dotted;
  }
}
</style>
